module.exports = __webpack_public_path__ + "static/media/innerLogo.abcc34c8.png";